 
import { defineStore } from 'pinia';
import { TRouterInfo, TTabRouterType } from '../../types/interface';
import { removeKey} from '../../utils/localStorage';


//不要删，娄底用的路由，可以重定向到路由守卫然后重定向到首页
const homeRoute: Array<TRouterInfo> = [
  {
    path: '/',
    isHome: true,
  }
];

const state = {
  tabRouterList: homeRoute,
  isRefreshing: false,
  currItem: {}
};

// 不需要做多标签tabs页缓存的列表 只为每个页面对应的name 如 DashboardDetail
const ignoreCacheRoutes = ['login'];
const lostoName ='tabsRouter';

export const useTabsRouterStore = defineStore('tabsRouter', {
  state: () => state,
  getters: {
    tabRouters: (state: TTabRouterType) => state.tabRouterList,
    refreshing: (state: TTabRouterType) => state.isRefreshing,
    current: (state: TTabRouterType) => state.currItem
  },
  actions: {
    // 处理刷新
    toggleTabRouterAlive(routeIdx: number) {
      this.isRefreshing = !this.isRefreshing;
      console.log('当前路由 ', this.tabRouters[routeIdx]);
      this.tabRouters[routeIdx].isAlive = !this.tabRouters[routeIdx].isAlive;
    },
    // 处理新增
    appendTabRouterList(newRoute: TRouterInfo) {
      console.log("+++++新增>", newRoute);
      this.currItem = newRoute;
      // if(newRoute.path != '/result/404'){
        const needAlive = !ignoreCacheRoutes.includes(newRoute.name as string);
        if (!this.tabRouters.find((route: TRouterInfo) => route.path === newRoute.path)) {
          // eslint-disable-next-line no-param-reassign
          this.tabRouterList = this.tabRouterList.concat({ ...newRoute, isAlive: needAlive });
        }
        // setKeyJsonStr(lostoName, this.tabRouterList);
      // }
    },
    // 处理关闭当前
    subtractCurrentTabRouter(newRoute: TRouterInfo) {
      const { routeIdx } = newRoute;
      this.tabRouterList = this.tabRouterList.slice(0, routeIdx).concat(this.tabRouterList.slice(routeIdx + 1));
      // setKeyJsonStr(lostoName, this.tabRouterList);
    },
    // 处理关闭右侧
    subtractTabRouterBehind(newRoute: TRouterInfo) {
      const { routeIdx } = newRoute;
      this.tabRouterList = this.tabRouterList.slice(0, routeIdx + 1);
      // setKeyJsonStr(lostoName, this.tabRouterList);
    },
    // 处理关闭左侧
    subtractTabRouterAhead(newRoute: TRouterInfo) {
      const { routeIdx } = newRoute;
      this.tabRouterList = homeRoute.concat(this.tabRouterList.slice(routeIdx));
      // setKeyJsonStr(lostoName, this.tabRouterList);
    },
    // 处理关闭其他
    subtractTabRouterOther(newRoute: TRouterInfo) {
      const { routeIdx } = newRoute;
      this.tabRouterList = routeIdx === 0 ? 
      homeRoute : homeRoute.concat([this.tabRouterList?this.tabRouterList[routeIdx]:'']);
      // setKeyJsonStr(lostoName, this.tabRouterList);
    },
    removeTabRouterList() {
      this.tabRouterList = [];
      this.tabRouterList = homeRoute;
      removeKey(lostoName);
    },
    initTabRouterList(newRoutes: TRouterInfo[]) {
      console.log("初始化>", newRoutes);
      newRoutes?newRoutes.forEach((route: TRouterInfo) => this.appendTabRouterList(route)):undefined;
    },
  },

});

/*
export function gxetTabsRouterStore() {
  return useTabsRouterStore( );
}
*/